import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { CustomersBoResponse } from '@utils/types/back-office/customers';
import { useAppSearchParams } from '@utils/hooks/use-app-search-params.ts';
import { getEncodedFilters } from '@utils/extensions/filter.extension.ts';

export const useGetResellerCustomers = (searchQuery: string) => {
  const { searchParams, filters } = useAppSearchParams();
  const offset = parseInt(searchParams.offset || '0');
  const limit = parseInt(searchParams.limit || '25');
  const filtersString = getEncodedFilters(filters);

  const fetchResellerCustomers = async (
    offset: number,
    limit: number,
    filters: string,
    searchQuery: string
  ) => {
    let url = GET_URL(
      offset.toString(),
      limit.toString(),
      filters,
      searchQuery
    ).resellerCustomer;

    if (searchQuery) {
      url = url.replace(/&+$/, '');
      url += `&q=${encodeURIComponent(`name:ilike:%${searchQuery}%`)}`;
    }

    const response = await Axios.get<CustomersBoResponse>(url);
    return response.data;
  };

  return useQuery<CustomersBoResponse, AxiosError<BaseError>>(
    ['resellerCustomers', offset, limit, filtersString, searchQuery],
    () => fetchResellerCustomers(offset, limit, filtersString, searchQuery),
    {
      enabled: true,
      useErrorBoundary: false
    }
  );
};
